const CDN_BASE_URL = process.env.REACT_APP_CDN_BASE_URL || "https://d2jt7oq4i1dt8c.cloudfront.net";

export function getImageUrl(filename) {
  if (!filename) return null;
  return `${CDN_BASE_URL}/uploads/${filename}`;
}
